/**
 * @description Статус провала.
 * @type {string}
 */
export const STATUS_FAIL = 'fail';

/**
 * @description Статус ожидания.
 * @type {string}
 */
export const STATUS_WAIT = 'wait';

/**
 * @description Задержка перед выполнением в мс.
 * @type {string}
 */
const DELAY = 5000;

/**
 * @description Примесь секретного ключа онлайн чека.
 * @type {any}
 */
export default {
  data() {
    return {
      /**
       * @description Ожидание завершения выполнения команды.
       * @type {boolean}
       */
      isAwaitCommandExecuted: false,
      /**
       * @description Действия.
       * @type {array[]}
       */
      onlineCheckActions: [],
    };
  },
  methods: {
    /**
     * @description Обновить действия команды Онлайн-чеков.
     * @param {string[]} actions
     * @returns {void}
     */
    updateOnlineCheckCommandActions(actions) {
      this.onlineCheckActions = actions;
    },
    /**
     * @description Ожидание выполнения команды.
     * @param {number} commandId Идентификатор команды.
     * @returns {Promise}
     */
    waitExecuted(commandId) {
      this.isAwaitCommandExecuted = true;
      const isCompleted = (result) => result.status !== STATUS_WAIT;
      const execute = () => this.$cashboxGateway.getCommandResult(commandId);
      return new Promise((resolve, reject) => {
        const repeat = () => setTimeout(() => {
          execute().then((result) => result.fold(
            (error) => reject(error),
            (response) => {
              if (isCompleted(response)) {
                this.updateOnlineCheckCommandActions([]);
                return resolve(response);
              }
              if (response.status === STATUS_WAIT && response.actions) {
                this.updateOnlineCheckCommandActions(response.actions);
              } else {
                this.updateOnlineCheckCommandActions([]);
              }
              return repeat();
            },
          ));
        }, DELAY);
        repeat();
      });
    },
  },
};
